import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlSegment, UrlTree } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { SocketConnectionService } from '../sockets/socket-connection.service';

const buildLoginRedirect = (router: Router, returnUrl: string): UrlTree =>
  router.createUrlTree(['/login'], { queryParams: { returnUrl } });

const resolveAttemptedUrl = (segments: readonly UrlSegment[]): string => {
  const path = segments.map((segment) => segment.path).filter(Boolean).join('/');
  return path.length > 0 ? `/${path}` : '/';
};

const checkLogin = (
  authService: AuthService,
  socketConnectionService: SocketConnectionService,
  router: Router,
  returnUrl: string,
): true | UrlTree => {
  if (authService.isLoggedIn()) {
    return true;
  }

  socketConnectionService.desconectarConnection();
  return buildLoginRedirect(router, returnUrl);
};

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const socketConnectionService = inject(SocketConnectionService);
  const router = inject(Router);

  return checkLogin(authService, socketConnectionService, router, state.url);
};

export const authMatchGuard: CanMatchFn = (_route, segments) => {
  const authService = inject(AuthService);
  const socketConnectionService = inject(SocketConnectionService);
  const router = inject(Router);

  return checkLogin(
    authService,
    socketConnectionService,
    router,
    resolveAttemptedUrl(segments),
  );
};
